import { trustedMcpServersListSchema, } from '../contracts/trusted-mcps';
import { parseSchema } from '../errors';
/**
 * List all trusted MCP servers (KIR-2376).
 *
 * Returns the Kirin-managed list of vetted MCP server vendors that
 * skip Phase 1 detection in the scanner. The list is immutable per
 * release — there is no companion mutation endpoint. To opt out of an
 * individual trusted vendor, customers add a matching tenant `block`
 * rule via the regular `/policy-exceptions` API.
 */
export async function listTrustedMcps(client) {
    const response = await client.get('/system/trusted-mcps');
    return parseSchema(trustedMcpServersListSchema, response);
}
//# sourceMappingURL=system.js.map